import jwtDecode from 'jwt-decode'
import { TYPES } from '../actions/user'

const token = localStorage.Auth || null

const initialState = {
  token,
  isLoggedIn: !!token,
  detail: !!token ? jwtDecode(token) : {},
  loginMessage: null,
  pwReset: false
}

export default (state = initialState, action) => {
  switch (action.type) {
    case TYPES.USER_LOGOUT:
      localStorage.removeItem('Auth')
      return {
        token: null,
        isLoggedIn: false,
        detail: {}
      }
    case TYPES.USER_LOGIN:
      let token = action.payload.token
      localStorage.Auth = token
      return {
        token,
        isLoggedIn: true,
        detail: jwtDecode(token)
      }
    case TYPES.SET_LOGIN_MESSAGE:
      return {
        ...state,
        loginMessage: action.payload
      }
    case TYPES.DEL_LOGIN_MESSAGE:
      return {
        ...state,
        loginMessage: null
      }
    case TYPES.GET_ME:
      return {
        ...state,
        detail: action.payload,
        loginMessage: null
      }
    case TYPES.PASSWORD_RESET:
      return {
        ...state,
        pwReset: true
      }

    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/user.js